export default "__VITE_ASSET__mY4B4mMW__"